/**
 * CoPilot – parent action types.
 * Aligned with Python API socket events: dcp_loading_status, dcp_action_detected, dcp_ai_answer, dcp_ai_error.
 * Sub-features (e.g. TaskSuggests, SubTaskSuggests, Analyses) can live in subfolders.
 */

// Request lifecycle
export const DCP_REQUEST_START = "DCP_REQUEST_START";
export const DCP_REQUEST_END = "DCP_REQUEST_END";

// Socket-driven (from AI API)
export const DCP_LOADING_STATUS = "DCP_LOADING_STATUS";
export const DCP_ACTION_DETECTED = "DCP_ACTION_DETECTED";
export const DCP_AI_ANSWER = "DCP_AI_ANSWER";
export const DCP_AI_ERROR = "DCP_AI_ERROR";

// Streaming (normalSpeaking, analyse)
export const DCP_STREAM_CHUNK = "DCP_STREAM_CHUNK";
export const DCP_STREAM_DONE = "DCP_STREAM_DONE";
export const DCP_STREAM_THINKING_CHUNK = "DCP_STREAM_THINKING_CHUNK";
export const DCP_MEDIA_BLOCK = "DCP_MEDIA_BLOCK";
export const DCP_MEDIA_STATUS = "DCP_MEDIA_STATUS";
export const DCP_MEDIA_DONE = "DCP_MEDIA_DONE";

// Reset / UI
export const DCP_RESET = "DCP_RESET";

// Pipeline steps timeline (for CopilotTimeline component)
export const DCP_PIPELINE_STEP = "DCP_PIPELINE_STEP";
export const DCP_PIPELINE_STEPS_RESET = "DCP_PIPELINE_STEPS_RESET";

// Selected mentions (persist across submit; clear only via UI)
export const DCP_MENTIONS_ADD = "DCP_MENTIONS_ADD";
export const DCP_MENTION_REMOVE = "DCP_MENTION_REMOVE";
export const DCP_MENTIONS_CLEAR = "DCP_MENTIONS_CLEAR";
export const DCP_MENTIONS_BACKUP = "DCP_MENTIONS_BACKUP";
export const DCP_MENTIONS_RESTORE = "DCP_MENTIONS_RESTORE";

// Current chat (so backend appends to same chat)
export const DCP_SET_CHAT_ID = "DCP_SET_CHAT_ID";
export const DCP_CLEAR_CHAT_ID = "DCP_CLEAR_CHAT_ID";
// Chat history list for the board
export const DCP_CHAT_LIST_SET = "DCP_CHAT_LIST_SET";
export const DCP_CHAT_LIST_APPEND = "DCP_CHAT_LIST_APPEND";
export const DCP_CHAT_LIST_ADD = "DCP_CHAT_LIST_ADD";
export const DCP_CHAT_LIST_UPDATE = "DCP_CHAT_LIST_UPDATE";
export const DCP_CHAT_LIST_REMOVE = "DCP_CHAT_LIST_REMOVE";

// Temporary private mode — ephemeral, not persisted in DB
export const DCP_SET_TEMPORARY_MODE = "DCP_SET_TEMPORARY_MODE";

// Human-in-the-Loop questions
export const DCP_HIL_QUESTION = "DCP_HIL_QUESTION";
export const DCP_HIL_CLEAR = "DCP_HIL_CLEAR";
export const DCP_HIL_REMOVE_QUESTION = "DCP_HIL_REMOVE_QUESTION";

// Owner-scoped browser task progress (latest view-only preview only)
export const DCP_BROWSER_TASK_UPDATE = "DCP_BROWSER_TASK_UPDATE";
